'use strict';
// var doman_link = 'https://dddemo.net/php/2025/vijay/Virag/virag_test/';
var doman_link = 'https://shopify.dress-and-safe.de/DD-dress-and-safe/';

const appSettings = {
  "status": true,
  "settings": {
    "notification_messages": {
      "GENERAL_ERROR": "Error. Unknown system response. Controller: ProductController",
      "CANVAS_EMPTY": "Select product to perform this action",
      "IMAGE_SIZE": "Image is too large (MAX SIZE: 300*300)",
      "WORDCLOUD_EMPTY": "Please enter some words for generate wordcloud.",
      "TYPE_NUMBER_REQUIRED": "Only numbers is allowed"
    },
    "request_url": {
      "LOAD_PRODUCTS": `${doman_link}dummy_data/products/load_products.json`,
      "LOAD_PRODUCT_SUB_IMAGES": `${doman_link}dummy_data/products/`,
      "LOAD_GRAPHICS": `${doman_link}dummy_data/graphics/`,
      "LOAD_COLOR_SCHEME": `${doman_link}inc/theme.php`,
      "SAVE_DESIGN": `${doman_link}inc/save_design.php`,
      "SAVE_UPLOAD_FILE": `${doman_link}inc/save_uploadfile.php`
    },
    "general_settings": {
      "loadMore": true,
      "graphicsPage": 1,
      "defaultProductId": 1,
      "defaultProductImage": `${doman_link}dummy_data/products/Poloshirts/Poloshirts-1.png`,
      "quantity": 1,
      "defaultPrice": 210,
      "defaultCurrency": "USD",
      "defaultProductTitle": "Poloshirts",
      "qrCode": "qrcode",
      "enter_drawing_mode": "Enter Drawing Mode",
      "drawing_mode_selector": "Pencil",
      "drawing_line_width": 30,
      "drawing_color": "#000000",
      "drawing_line_shadow": 0,
      "primaryColor": "#26C4E2",
      "secondaryColor": "#ffffff",
      "graphicsCategory": "Flat Icons",
        "graphicsCategories":{
        "Flat Icons": "Flat Icons",
        "ClipArts": "ClipArts",
        "Flags": "Country Flags",
        "Shapes": "Shapes",
        "Quotes": "Quotes",
        "Badges": "Badges",
        "Zodiac": "Zodiac Sign"
      },
      "productCategories":{
        "All" : "All",
        "Clothes" : "Clothes",
        "Bottles" : "Bottles",
        "Others" : "Others"
      },
      "productByName": "DESC",
      "productByNames": {
        "ASC": "ASC",
        "DESC": "DESC"
      },
      "predicate": "id",
      "reverse": false
    },
    "social_settings": {
      "fb_app_id": 101994476846984
    }
  },
  "message": "Settings Loaded Successfully"
};
const productImages = {
  status: true,
  images: [
    `${doman_link}dummy_data/products/Poloshirts/Poloshirts-1.png`,
    `${doman_link}dummy_data/products/Poloshirts/Poloshirts-2.png`,
    `${doman_link}dummy_data/products/Poloshirts/Poloshirts-3.png`,
    `${doman_link}dummy_data/products/Poloshirts/Poloshirts-4.png`
  ],
  message: "Images Loaded Successfully"
};

angular.module('productApp', [
    'common.fabric',
    'common.fabric.utilities',
    'common.fabric.constants',
    'colorpicker.module',
    'ngSanitize',
    'ngMaterial',
    'ngScrollbar',
    'ngFileUpload'
]).controller('ProductCtrl', [
    '$scope',
    'Fabric',
    'FabricConstants',
    'Keypress',
    '$http',
    '$timeout',
    '$mdDialog',
    '$mdToast',
    'Upload',
    function ($scope, Fabric, FabricConstants, Keypress, $http, $timeout, $mdDialog, $mdToast, Upload) {
        $scope.fabric = {};
        $scope.status = '  ';

        var _this = this;
        var last = {
            bottom: true,
            top: false,
            left: false,
            right: true
        };

        // var SETTINGS_INIT_URL = "https://cdn.shopify.com/s/files/1/0613/8691/6049/files/newsettings.json?v=1747377457";
     var SETTINGS_INIT_URL = `${doman_link}inc/json/settings.json`;

        
        $scope.NOTIFICATION_MESSAGES = [];
        $scope.REQUEST_URL = [];

        $scope.products = [];
        $scope.productImages = [];
        $scope.graphics = [];
        $scope.objectLayers = [];
        $scope.isloaded = true;
        $scope.alertMessage = '';
        $scope.activeDesignObject = 0;
        $scope.isMenuClicked = true;
        $scope.enter_drawing_status = false;
        $scope.FabricConstants = FabricConstants;
        $scope.jsonStore = {};
        $scope.json_select_opton = {};
        $scope.finaljson = {};
        $scope.PDFimageUrls = [];
        // $scope.select_already_prosnolize = $scope.scroup.alwo || [];
       $scope.closet_element = null;
      $scope.avalable_customise = null;
      $scope.Veredelung = 'Stick';

        $scope.changeColorScheme = function () {
            $http({
                method: 'post',
                url:$scope.REQUEST_URL.LOAD_COLOR_SCHEME,
                data: {
                    primaryColor: $scope.primaryColor,
                    secondaryColor: $scope.secondaryColor
                },
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                transformRequest: _this.transformRequest
            }).success(function (data, status, headers, config) {
                $('.css_gen').html(data);
            }).error(function (data, status, headers, config) {
                $scope.isloaded = false;
                $scope.$broadcast("AjaxCallHappened",false);
            });
            $(".customizer").removeClass('customizer_toggle');
            $("body").removeClass('body_overlay');
        };

        $scope.enterDrawingMode = function(){
            if($scope.fabric.checkBackgroundImage()){
                if($scope.fabric.toggleDrawing() == 'Cancel'){
                    $scope.enter_drawing_mode = 'Cancel Drawing Mode';
                    $scope.enter_drawing_status = true;
                }else{
                    $scope.enter_drawing_mode = 'Enter Drawing Mode';
                    $scope.enter_drawing_status = false;
                    $scope.fabric.resetBrush($scope.drawing_mode_selector, $scope.drawing_color, $scope.drawing_line_width, $scope.drawing_line_shadow);
                }
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.enterDrawing = function(){
            if($scope.fabric.checkBackgroundImage()){
                
                $scope.fabric.enterDrawing();
                $scope.enter_drawing_mode = 'Cancel Drawing Mode';
                $scope.enter_drawing_status = true;
                
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.exitDrawing = function(){
            if($scope.fabric.checkBackgroundImage()){
                
                $scope.fabric.exitDrawing();
                $scope.enter_drawing_status = true;
                
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        // $scope.changeDrawingMode = function(mode){
        //     if($scope.fabric.checkBackgroundImage()){
        //         $scope.fabric.changeDrawingMode(mode, $scope.drawing_color, $scope.drawing_line_width, $scope.drawing_line_shadow);
        //     }else{
        //         _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
        //     }
        // };

       $scope.changeDrawingMode = function(mode){
              $scope.Veredelung = mode; // update the model
        };


        $scope.fillDrawing = function(color){
            if($scope.fabric.checkBackgroundImage()){
                $scope.drawing_color = color;
                $scope.fabric.fillDrawing(color);
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.changeDrawingWidth = function(width){
            if($scope.fabric.checkBackgroundImage()){
                $scope.drawing_line_width = width;
                $scope.fabric.changeDrawingWidth(width);
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.changeDrawingShadow = function(shadow){
            if($scope.fabric.checkBackgroundImage()){
                $scope.drawing_line_shadow = shadow;
                $scope.fabric.changeDrawingShadow(shadow);
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.makeCode = function(elText) {
            var qrcodesvg 	= new Qrcodesvg( elText, $scope.qrCode, 150);
            qrcodesvg.draw();
        };

        $scope.addShape = function (path) {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.addShape(path);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };
        $scope.addImage = function (image) {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.addImage(image);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.onFileSelect = function(file) {
            if(file !== null) {
                if ($scope.fabric.checkBackgroundImage()) {
                  //   var URL = window.URL || window.webkitURL;
                  //   var srcTmp = URL.createObjectURL(file);
                  // console.log("test_test_URl_upload-URL",URL);
                  //  console.log("test_test_URl_upload-srcTmp",srcTmp);
                  $scope.saveupload_file(file);
                    // $scope.fabric.addImage(srcTmp);
                    // $scope.objectLayers = [];
                    // $scope.objectLayers = $scope.fabric.canvasLayers();
                } else {
                    _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
                }
            }
        };

        $scope.clearAll = function () {

            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure you want to clear canvas? This will remove all design elements you have created.')
                .ariaLabel('Confirm')
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                $scope.fabric.clearCanvas();
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();

            });
        };

        $scope.clearCanvas = function (){

                $scope.fabric.clearCanvas();
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();

        };

        $scope.removeSelectedObject = function () {

            var confirm = $mdDialog.confirm()
                .title('')
                .content('Are you sure you want to remove selected layer? this will remove the selected layer/design element.')
                .ariaLabel('Confirm')
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                $scope.fabric.deleteActiveObject();
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();

            });
        };

        $scope.deactivateAll = function () {
            $scope.fabric.deactivateAll();
            $scope.exitDrawing();
            $scope.objectLayers = [];
            $scope.objectLayers = $scope.fabric.canvasLayers();
            $scope.$broadcast('rebuild:me');
        };

        $scope.verticalAlign = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.centerV();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }

        };

        $scope.horizontalAlign = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.centerH();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }

        };

        $scope.backwordSwap = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.sendBackwards();
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }

        };

        $scope.objectBackwordSwap = function (object) {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.objectSendBackwards(object);
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }

        };

        $scope.forwardSwap = function () {

            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.bringForward();
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.objectForwardSwap = function (object) {

            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.objectBringForward(object);
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.layers =  function () {

                $scope.deactivateAll();

                var activeTab;
                activeTab = $('#tabs').find('li.active');
                $("#my-tab-content > div.active").removeClass('active');
                $(activeTab).removeClass('active');
                $('#Layers').addClass('active');
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
                $scope.$broadcast('rebuild:layer');

        };

        $scope.$on('scrollbar.show', function(){ 
        });

        $scope.$on('scrollbar.hide', function(){ 
        });

        $scope.copyItem =  function () {
            if($scope.fabric.checkBackgroundImage()){
                if($scope.fabric.copyItem() == 'DONE') {
                    _this.showNotification('Object Copied!', false);
                    $scope.objectLayers = [];
                    $scope.objectLayers = $scope.fabric.canvasLayers();
                }
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.pasteItem =  function () {
            if($scope.fabric.checkBackgroundImage()){
                if($scope.fabric.pasteItem() == 'DONE') {
                    _this.showNotification('Object Paste!', false);
                    $scope.objectLayers = [];
                    $scope.objectLayers = $scope.fabric.canvasLayers();
                }
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.addQRCode = function(text){
            if($scope.fabric.checkBackgroundImage()){
                if(typeof text != "undefined") {
                    $scope.makeCode(text);
                    setTimeout(function () {
                        var srcVal = $('#' + $scope.qrCode).html();
                        $scope.fabric.addShapeString(srcVal);
                        $('#' + $scope.qrCode).html('');
                        $scope.objectLayers = [];
                        $scope.objectLayers = $scope.fabric.canvasLayers();
                    }, 500);
                }
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.addText = function () {

          console.log("$scope.fabric.selectedObject.text",$scope.fabric.selectedObject.text)
          
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.addText($scope.fabric.selectedObject.text);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.addTextByAction = function () {
            
            $scope.deactivateAll();
          console.log($scope.fabric.checkBackgroundImage() && $scope.isMenuClicked);

            if($scope.fabric.checkBackgroundImage() && $scope.isMenuClicked){
                $scope.fabric.addText();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
                $scope.isMenuClicked = false;
            }
        };

        $scope.addWordCloud = function () {
            if($scope.fabric.checkBackgroundImage()){
                if(typeof $scope.fabric.selectedObject.textWordCloud != "undefined" && $scope.fabric.selectedObject.textWordCloud != '') {
                    $scope.fabric.addWordCloud($scope.fabric.selectedObject.textWordCloud);
                    $scope.objectLayers = [];
                    $scope.objectLayers = $scope.fabric.canvasLayers();
                }else{
                    _this.showNotification($scope.NOTIFICATION_MESSAGES.WORDCLOUD_EMPTY, true);
                }
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.lockObject = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleLockActiveObject();
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.lockLayerObject = function (object){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleLockObject(object);
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.flipObject = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleFlipX();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.saveObject = function () {

            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.saveCanvasObject();

                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };


        $scope.saveObjectAllFormat = function () {
            if($scope.fabric.checkBackgroundImage()){

                $scope.beforeSave();
                var objects_svg = $scope.fabric.designedSVGObjects;
            
                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'svg',
                        object: JSON.stringify(objects_svg)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });

                $scope.beforeSave();
                var objects_png = $scope.fabric.designedPNGObjects;
                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'png',
                        object: JSON.stringify(objects_png)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                    
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });

                $scope.beforeSave();
                var objects_jpg = $scope.fabric.designedJPGObjects;
            
                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'jpg',
                        object: JSON.stringify(objects_jpg)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                    
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });


                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };


        $scope.saveObjectAsSvg = function () {

            if($scope.fabric.checkBackgroundImage()){
               $scope.beforeSave();

                var objects = $scope.fabric.designedSVGObjects;
                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'svg',
                        object: JSON.stringify(objects)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                    if(data.status){
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                .title('Design Saved')
                                .textContent('Design has been saved. You can find them into "saved_design" directory.')
                                .ariaLabel('Success')
                                .ok('Got it!')
                        );
                    }
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });

                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.saveObjectAsPng = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.beforeSave();
                var objects = $scope.fabric.designedPNGObjects;              
                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'png_json',
                        object: JSON.stringify(objects)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                    if(data.status){
                      console.log(data.filename);
                      $scope.savejsononpropertes(data.filename);
                        // $mdDialog.show(
                        //     $mdDialog.alert()
                        //         .parent(angular.element(document.querySelector('#popupContainer')))
                        //         .clickOutsideToClose(true)
                        //         .title('Design Saved')
                        //         .textContent('Design has been saved. You can find them into "saved_design" directory.')
                        //         .ariaLabel('Success')
                        //         .ok('Got it!')
                        // );
                    }
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });

                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };








//         $scope.exportAllDesignPNGs = function () {
//     $scope.allPNGs = {}; // final PNG collection

//     angular.forEach($scope.jsonStore, function (jsonString, key) {
//         if (!jsonString) return;

//         try {
//             var json = JSON.parse(jsonString);
//         } catch (e) {
//             console.error("Invalid JSON at key:", key);
//             return;
//         }

//         // Create temp canvas
//         var tempCanvas = new fabric.Canvas(document.createElement('canvas'));
//         tempCanvas.setWidth(json.width || 500);
//         tempCanvas.setHeight(json.height || 500);

//         // Load fabric JSON
//         tempCanvas.loadFromJSON(json, function () {
//             tempCanvas.renderAll();

//             // Export to PNG
//             var png = tempCanvas.toDataURL({
//                 format: "png"
//             });

//             // Save into final object
//             $scope.allPNGs[key] = png;

//             console.log("Exported PNG for key:", key);
//         });
//     });
// };

$scope.exportAllDesignPNGs = async function () {
    let result = {};

    // Convert each JSON → PNG using await
    const convertKeys = Object.keys($scope.jsonStore).map(async (key) => {
        const jsonString = $scope.jsonStore[key];

        // default
        result[key] = null;

         const isValid = $scope.hasRectAndOthers(jsonString);
        // If validation true → add to object
        if (!isValid === true) {
           return; // continue
        }


        if (!jsonString || jsonString === "null") {
            return; // continue
        }

        let json;
        try {
            json = JSON.parse(jsonString);
        } catch (e) {
            console.error("Invalid JSON at key:", key);
            return;
        }

        // Return a promise that resolves after PNG creation
        result[key] = await new Promise((resolve) => {
            const tempCanvas = new fabric.Canvas(document.createElement('canvas'));
            tempCanvas.setWidth(json.width || 500);
            tempCanvas.setHeight(json.height || 500);

            tempCanvas.loadFromJSON(json, function () {
                tempCanvas.renderAll();

                const png = tempCanvas.toDataURL("image/png");
                resolve(png);
            });
        });
    });

    // Wait for all PNG conversions to complete
    await Promise.all(convertKeys);

    // Store final result
    $scope.allPNGs = result;
    return result;
};






        $scope.fetchImagesAndGeneratePDF = async function () {
            // fetchImagesAndGeneratePDF();

              window.scrollTo({ top: 0, behavior: 'smooth' });
            angular.element(document.body).addClass("pdf-mode");

            if($scope.fabric.checkBackgroundImage()){
               
                $scope.beforeSavejson();
                var objects_new = $scope.fabric.designedJSONObjects;
                if(objects_new) $scope.addOrUpdateData(objects_new);

              const objects = await $scope.exportAllDesignPNGs();
                    console.log("ALL PNGs:", objects);

                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'png',
                        object: JSON.stringify(objects)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                    if(data.status){
                      console.log(data.filename);

                      $scope.GeneratePDF(data.filename);
                    }
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });

                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };



          $scope.GeneratePDF = function (images_object) {                
            $scope.PDFimageUrls = images_object;
            const element = document.getElementById("pdfContent");

                // Show the element temporarily
                const previousDisplay = element.style.display;
                element.style.display = "block";

                // Wait for rendering
                // await new Promise(resolve => setTimeout(resolve, 300));

                setTimeout(function () {

                html2canvas(element, {
                scale: 2,
                useCORS: true
                }).then(canvas => {
                const imgData = canvas.toDataURL("image/jpeg", 1.0);
                const { jsPDF } = window.jspdf;

                const pdf = new jsPDF("p", "mm", "a4");
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();

                const imgWidth = pageWidth;
                const imgHeight = canvas.height * (imgWidth / canvas.width);

                pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
                pdf.save("design-preview.pdf");

                // Hide again
                element.style.display = previousDisplay;
                angular.element(document.body).removeClass("pdf-mode");
                });
                }, 700); 

            };







      
        $scope.saveObjectAsJpg = function () {
            if($scope.fabric.checkBackgroundImage()){
                
                $scope.beforeSave();
                var objects = $scope.fabric.designedJPGObjects;
            
                $http({
                    method: 'post',
                    url:$scope.REQUEST_URL.SAVE_DESIGN,
                    data: {
                        type: 'jpg',
                        object: JSON.stringify(objects)
                    },
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    transformRequest: _this.transformRequest
                }).success(function (data, status, headers, config) {
                    if(data.status){
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                .title('Design Saved')
                                .textContent('Design has been saved. You can find them into "saved_design" directory.')
                                .ariaLabel('Success')
                                .ok('Got it!')
                        );
                    }
                }).error(function (data, status, headers, config) {
                    $scope.$broadcast("AjaxCallHappened",false);
                });

                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };


       $scope.saveObjectAsJson = function () {
            if($scope.fabric.checkBackgroundImage()){

               $scope.beforeSavejson();
                var objects = $scope.fabric.designedJSONObjects;
                 var objects = $scope.fabric.designedJSONObjects;
                        if(objects){
                           $scope.addOrUpdateData(objects);
                        }
              $scope.saveObjectAsPng();
            //   $scope.beforeSavejson();
                       
              
              console.log("$scope.fabric.exportCanvasObjectAsJson()",objects);
                // $scope.();
                // var objects = $scope.fabric.designedPNGObjects;              
                // $http({
                //     method: 'post',
                //     url:$scope.REQUEST_URL.SAVE_DESIGN,
                //     data: {
                //         type: 'png',
                //         object: JSON.stringify(objects)
                //     },
                //     headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                //     transformRequest: _this.transformRequest
                // }).success(function (data, status, headers, config) {
                //     if(data.status){
                //         $mdDialog.show(
                //             $mdDialog.alert()
                //                 .parent(angular.element(document.querySelector('#popupContainer')))
                //                 .clickOutsideToClose(true)
                //                 .title('Design Saved')
                //                 .textContent('Design has been saved. You can find them into "saved_design" directory.')
                //                 .ariaLabel('Success')
                //                 .ok('Got it!')
                //         );
                //     }
                // }).error(function (data, status, headers, config) {
                //     $scope.$broadcast("AjaxCallHappened",false);
                // });

                // $scope.objectLayers = [];
                // $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };




       $scope.saveupload_file = function (file) {       
          var formData = new FormData();
          formData.append('file', file); // Pass file object
          formData.append('type', 'png'); // Additional data
      
          $http.post($scope.REQUEST_URL.SAVE_UPLOAD_FILE, formData, {
              transformRequest: angular.identity,
              headers: { 'Content-Type': undefined } // Let browser set multipart/form-data
          })
          .success(function (data) {
              if (data.status) {
                  // console.log("Uploaded file:", data.filename);
                    $scope.fabric.addImage(data.filename);
                    $scope.objectLayers = [];
                    $scope.objectLayers = $scope.fabric.canvasLayers();
              } else {
                  console.log("Upload failed:", data.message);
              }
          })
          .error(function (err) {
              console.log("Error:", err);
          });
      };

      
      
      

      

        $scope.downloadObject = function () {

            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.downloadCanvasObject();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }

        };

        $scope.downloadObjectAsPdf = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.downloadCanvasObjectAsPDF();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };
       


        $scope.printObject = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.printCanvasObject();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.undo = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.undo();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.redo = function () {
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.redo();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.zoomObject = function (action) {

            if($scope.fabric.checkBackgroundImage()){
                if(action == 'zoomin') {
                    $scope.fabric.zoomInObject();
                }else if(action == 'zoomout'){
                    $scope.fabric.zoomOutObject();
                }else{
                    $scope.fabric.resetZoom();
                }
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.curveText = function(){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleText();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }
        };

        $scope.toggleBold = function(){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleBold();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }
        };

        $scope.toggleItalic = function(){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleItalic();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }
        };

        $scope.toggleUnderline = function(){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleUnderline();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }
        };

        $scope.toggleLinethrough = function(){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.toggleLinethrough();
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }
        };

        $scope.toggleFont = function (font){
            if($scope.fabric.checkBackgroundImage()){
                $scope.fabric.selectedObject.fontFamily = font;
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
            }
        };

        $scope.isLocked = function(){
            if($scope.fabric.checkBackgroundImage()){
                return $scope.fabric.isLocked();
            }else{
                return false;
            }
        };

        $scope.isObjectLocked = function(object){
            if($scope.fabric.checkBackgroundImage()){
                return $scope.fabric.isObjectLocked(object);
            }else{
                return false;
            }
        };




      

        $scope.$on('AjaxCallHappened', function (event, data) {
            if (data.status == true) {
                _this.showNotification(data.message, false);
            }  else {
                _this.showNotification($scope.NOTIFICATION_MESSAGES.GENERAL_ERROR, false);
            }
        });
        $scope.addImageUpload = function (data) {
            var obj = angular.fromJson(data);
            $scope.addImage(obj.filename);
        };
        $scope.selectCanvas = function () {
            $scope.canvasCopy = {
                width: $scope.fabric.canvasOriginalWidth,
                height: $scope.fabric.canvasOriginalHeight
            };
        };
        $scope.setCanvasSize = function () {
            $scope.fabric.setCanvasSize($scope.canvasCopy.width, $scope.canvasCopy.height);
            $scope.fabric.setDirty(true);
            delete $scope.canvasCopy;
        };

        $scope.fillColor  = function (value) {
            $scope.fabric.selectedObject.fill = value;
        };

        $scope.fillTint = function (value){
            $scope.fabric.selectedObject.tint = value;
            $scope.fabric.applyTint();
        };

        $scope.resetTint = function (){
            $scope.fabric.resetTint();
        };

        $scope.toggleTint = function (value){
            $scope.fabric.selectedObject.tint = value;
            $scope.fabric.toggleTint();
        };

        $scope.toggleReverse = function (value){
            $scope.fabric.toggleReverse(value);
        };

        $scope.radius = function (value) {
            $scope.fabric.radius(value);
        };

        $scope.spacing = function (value) {
            $scope.fabric.spacing(value);
        };

        $scope.opacity = function (value) {
            $scope.fabric.selectedObject.opacity = value;
        };



        $scope.deleteObject = function (object){

            var confirm = $mdDialog.confirm()
                .title('')
                .content('Are you sure you want to remove selected object?')
                .ariaLabel('Confirm')
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                $scope.fabric.deleteObject(object);
                $scope.fabric.setDirty(true);
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
                $scope.$broadcast('rebuild:layer');
            });
        };

        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            _this.sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };

        $scope.next = function() {
            $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
        };
        $scope.previous = function() {
            $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
        };

        $scope.updatePage = function(){
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Ohh!')
                    .content('You should buy this product, visit "http://designtailor.veepixel.com/"')
                    .ariaLabel('Alert Dialog')
                    .ok('Got it!')
            );
        };

        $scope.setImageFilter = function (checked, value){
           (checked == true) ? checked = false: checked = true;
            $scope.fabric.applyImageFilter(checked, value);
        };

        $scope.increment = function(item){
           item.count += 1;
        };

        $scope.counter = 1; 
        $scope.increments = function() {
            var countVal = $scope.counter; 
                $scope.counter++; 
            $scope.updateQuantity($scope.counter);
        };
        $scope.decrement = function() {
            var countVal = $scope.counter;
            if(countVal > 1){
                $scope.counter--;
            }
            $scope.updateQuantity($scope.counter);
        };

        $scope.updateQuantity = function (quantity) {
            if(!isNaN(quantity)){
                if(quantity <= 0){
                    $scope.quantity = 1;
                    $scope.defaultPrice = $scope.orignalPrice;
                }else{
                    $scope.defaultPrice = $scope.orignalPrice * quantity;
                }
            }else{
                $scope.quantity = 1;
                $scope.defaultPrice = $scope.orignalPrice;
                _this.showNotification($scope.NOTIFICATION_MESSAGES.TYPE_NUMBER_REQUIRED, true);
            }

        };

        $scope.addToCart = function () {

            if($scope.fabric.checkBackgroundImage()){
                $scope.saveObjectAllFormat();
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Thank You')
                        .textContent('Product has been saved and added to cart.')
                        .ariaLabel('Success')
                        .ok('Got it!')
                );
            }else{
                _this.showNotification($scope.NOTIFICATION_MESSAGES.CANVAS_EMPTY, true);
            }
        };

        $scope.beforeSave = function () {
                $scope.fabric.designedSVGObjects[$scope.activeDesignObject] = $scope.fabric.saveCanvasObjectAsSvg();
                $scope.fabric.designedPNGObjects[$scope.activeDesignObject] = $scope.fabric.saveCanvasObjectAsPng();
                $scope.fabric.designedJPGObjects[$scope.activeDesignObject] = $scope.fabric.saveCanvasObjectAsJpg();
        };


        $scope.beforeSavejson = function () {
                $scope.fabric.designedJSONObjects[$scope.activeDesignObject] = $scope.fabric.getJSON();

        };
      


          $scope.addOrUpdateData = function (dataObject) {
            
              if (!dataObject) {
                console.error("Invalid arguments passed to addOrUpdateData");
                return;
              }

                    // console.log("Incoming dataObject:", dataObject);
                    // console.log("jsonStore BEFORE:", $scope.jsonStore);

                    // --- FIX ---
                    // If jsonStore is empty OR not an object, initialize it
                    if (!$scope.jsonStore || typeof $scope.jsonStore !== "object") {
                        $scope.jsonStore = {};
                    }

                    // Merge and update values (only overwrite existing keys)
                    angular.forEach(dataObject, function (value, key) {
                        const jsonString = dataObject[key];
                         const isValid = $scope.hasRectAndOthers(jsonString);
                         console.log("isValid",isValid);
                         if (!isValid === true) {
                             return; // continue
                            }
                        $scope.jsonStore[key] = value;   // update only that index
                    });

                    // console.log("jsonStore AFTER:", $scope.jsonStore);

              const active_main_dessing = $scope.defaultProductId+ '_&&_' +$scope.activeDesignObject ;
            $scope.json_select_opton_fun(active_main_dessing,$scope.Veredelung);
          };
      





          $scope.allowVeredelungForImage = function (prodImg) {
            // return true;
                    if (!$scope.Veredelung) return true; // if no selection, allow all

                    // console.log("scope.Veredelung",prodImg.label,$scope.Veredelung , $scope.Veredelung === 'Stick',$scope.Veredelung === 'Druck'  )
                    if ($scope.Veredelung === 'Stick' && prodImg.is_Stick === true) {
                        return true;
                    }
                    if ($scope.Veredelung === 'Druck' && prodImg.is_Druck === true) {
                        return true;
                    }
                    return false;
                };





          $scope.hasRectAndOthers = function(jsonData) {
                        if (!jsonData) return false;

                        // If stored as string, parse it
                        if (typeof jsonData === 'string') {
                            try {
                            jsonData = JSON.parse(jsonData);
                            } catch (e) {
                            return false;
                            }
                        }

                        // console.log("jsonData_check",$scope.jsonStore)

                        // Must be a valid object with an array of objects
                        if (!jsonData.objects || !Array.isArray(jsonData.objects)) return false;

                        const hasRect = jsonData.objects.some(obj => obj.type === 'rect');
                        const moreThanOne = jsonData.objects.length > 1;

                        // Add class only if both are true
                        return hasRect && moreThanOne;
                        };




                                    $scope.hasRectAndOthers_pdf = function(objArray) {
                                        if (!objArray) return {};

                                        var filtered = {}; // <-- OBJECT, not array

                                        angular.forEach(objArray, function(item, index) {

                                            // console.log("Index:", index, "Item:", item);

                                            // Get jsonStore item by index
                                            //   console.log("$scope.jsonStore pdf",$scope.jsonStore);
                                            const jsonObj = $scope.jsonStore[index]; 
                                            // console.log("Index:", index, "Item:", item,"jsonStore",jsonObj);

                                            // Validate with your existing function
                                            const isValid = $scope.hasRectAndOthers(jsonObj);

                                            // If validation true → add to object
                                            if (isValid === true) {
                                                filtered[index] = item; // <-- store by index key
                                            } else {
                                                filtered[index] = null; // OPTIONAL: match your format
                                            }

                                        });

                                        return filtered; // returns object with keys
                                    };







            $scope.savejsononpropertes = function (images_object) {

                    let is_check = false
                console.log("scope.jsonStore",$scope.jsonStore)
                console.log("scope.jsonStore === null",$scope.jsonStore && Object.keys($scope.jsonStore).length === 0);

                    const convertKeys = Object.keys($scope.jsonStore).map(async (key) => {
                    const jsonString = $scope.jsonStore[key];
                    const isValid = $scope.hasRectAndOthers(jsonString);
                    // If validation true → add to object
                    if (!isValid === true && !is_check === true) {
                    return; // continue
                    }else{
                        is_check = true
                    }
                });
       
                console.log("is_check",is_check);

if(!is_check){

     const main_app = document.querySelector('#main-angular_product_wapper') || null;
                  if(main_app) main_app.classList.add('hidden');
                  const main_data_select = document.querySelector("[new_data_edit='outfit']") || null;
                  if(main_data_select) main_data_select.classList.remove('hidden'); 


     $scope.finaljson = {};
              $scope.jsonStore = {};
              $scope.json_select_opton = {};
              $scope.Veredelung = 'Stick';
              $scope.fabric.designedObjects = {};
              $scope.closet_element = null;
              $scope.avalable_customise = null;

    return;
}

                //   $scope.Veredelung = $scope.Veredelung + '_app_id_' + $scope.defaultProductId + '-' + $scope.activeDesignObject;

                $scope.finaljson= {
                  objects:$scope.jsonStore,
                  image_url: images_object,
                  Veredelung:$scope.json_select_opton
                };
               console.log("scope.finaljson",$scope.finaljson);
               if($scope.closet_element){
                 $scope.closet_element.querySelector('[data-main-custom-cart]').setAttribute('data-customize', JSON.stringify($scope.finaljson.objects));
                 $scope.closet_element.querySelector('[data-main-custom-cart]').setAttribute('data-customize-final-images', JSON.stringify($scope.finaljson.image_url));
                  $scope.closet_element.querySelector('[data-main-custom-cart]').setAttribute('data-customize-final-Veredelung', JSON.stringify($scope.finaljson.Veredelung));
               } 


                  const main_app = document.querySelector('#main-angular_product_wapper') || null;
                  if(main_app) main_app.classList.add('hidden');
                  const main_data_select = document.querySelector("[new_data_edit='outfit']") || null;
                  if(main_data_select) main_data_select.classList.remove('hidden'); 
              
              
              $scope.finaljson = {};
              $scope.jsonStore = {};
              $scope.json_select_opton = {};
              $scope.Veredelung = 'Stick';
              $scope.fabric.designedObjects = {};
              $scope.closet_element = null;
              $scope.avalable_customise = null;
            };

        $scope.prodctByCat = function (val){  
            $scope.productCategory = val;
        };

        $scope.hasCategory = function (product){
            var category = angular.lowercase($scope.productCategory);
            var pCat = angular.lowercase(product.category);
            return (category == "all" || category == pCat);
        }; 


      $scope.json_select_opton_fun = function(key, value) {
            $scope.json_select_opton[key] = value;
            // console.log("$scope.json_select_opton",$scope.json_select_opton);
        };



        $scope.loadProduct = function (title, image, id, price, currency, indexKey,object,allcanvasdata) {

 console.log("image indexKey",id,indexKey);

                // $scope.beforeSavejson();
                // var objects = $scope.fabric.designedJSONObjects || null;
                //     if(objects && indexKey){
                //     $scope.addOrUpdateData(objects);
                //     }

                //      let active_custom_json = $scope.jsonStore[indexKey];

                //      if(active_custom_json){
                //        console.log("active_custom_jsoncheck",active_custom_json);
                //     $scope.clearCanvas();
                //     setTimeout(function(){ 
                //         $scope.fabric.loadJSON(active_custom_json);
                //         $scope.objectLayers = [];
                //         $scope.objectLayers = $scope.fabric.canvasLayers();
                //     },500);
                //     }else{
                //           $scope.clearCanvas();
                //           $scope.fabric.addCanvasBackground(image,allcanvasdata);
                //           $scope.objectLayers = [];
                //           $scope.objectLayers = $scope.fabric.canvasLayers();
                //     } 

                //      $scope.defaultPrice = price;
                //     $scope.orignalPrice = price;
                //     $scope.defaultCurrency = currency;
                //     $scope.defaultProductTitle = title;
                //     _this.initProductSubImages(id);
          
          if($scope.avalable_customise != null){
            const check_null = indexKey;
            indexKey = (typeof indexKey === "undefined" || indexKey === null) ? 0 : indexKey;
                                $scope.beforeSavejson();
                        var objects = $scope.fabric.designedJSONObjects || null;
                        if(objects && check_null){
                           $scope.addOrUpdateData(objects);
                        }
            let active_custom_json = $scope.jsonStore[indexKey];
            console.log("active_custom_json",active_custom_json)
            if(!active_custom_json)  active_custom_json = $scope.avalable_customise[indexKey];
                    if(active_custom_json){
                       console.log("active_custom_jsoncheck",active_custom_json);
                    $scope.clearCanvas();
                    setTimeout(function(){ 
                        $scope.fabric.loadJSON(active_custom_json);
                        $scope.objectLayers = [];
                        $scope.objectLayers = $scope.fabric.canvasLayers();
                    },500);
                    }else{
                    //   console.log("active_custom_json2",active_custom_json);
                      if($scope.fabric.designedObjects[indexKey] != null){                  
                          $scope.fabric.loadJSON($scope.fabric.designedObjects[indexKey]);
                          $scope.objectLayers = [];
                          $scope.objectLayers = $scope.fabric.canvasLayers();
                      }else{
                          $scope.clearCanvas();
                          $scope.fabric.addCanvasBackground(image,allcanvasdata);
                          $scope.objectLayers = [];
                          $scope.objectLayers = $scope.fabric.canvasLayers();
                      }
                    }                            
                    $scope.defaultPrice = price;
                    $scope.orignalPrice = price;
                    $scope.defaultCurrency = currency;
                    $scope.defaultProductTitle = title;
                    _this.initProductSubImages(id);

            // $scope.activeDesignObject = indexKey;
            
          } else{        
             
            indexKey = (typeof indexKey == "undefined")? null:indexKey;
            $scope.counter = 1; 
            if(indexKey != null){
                      $scope.beforeSavejson();
                        var objects = $scope.fabric.designedJSONObjects || null;
                        if(objects){
                           $scope.addOrUpdateData(objects);
                        }

                $scope.fabric.designedObjects[$scope.activeDesignObject]  = $scope.fabric.exportCanvasObjectAsJson();
                $scope.fabric.designedSVGObjects[$scope.activeDesignObject] = $scope.fabric.saveCanvasObjectAsSvg();
                $scope.fabric.designedPNGObjects[$scope.activeDesignObject] = $scope.fabric.saveCanvasObjectAsPng();
                $scope.fabric.designedJPGObjects[$scope.activeDesignObject] = $scope.fabric.saveCanvasObjectAsJpg();

              // console.log(" $scope.fabric.designedObjects", $scope.fabric.designedObjects,$scope.activeDesignObject);
               // console.log("$scope.fabric.designedObjects[indexKey]",$scope.fabric.designedObjects[indexKey] != null);

                 console.log("object false indexKey",indexKey);
               console.log($scope.fabric.designedObjects,$scope.fabric.designedObjects[indexKey] != null);

                if($scope.fabric.designedObjects[indexKey] != null){                  
                    $scope.fabric.loadJSON($scope.fabric.designedObjects[indexKey]);
                    $scope.objectLayers = [];
                    $scope.objectLayers = $scope.fabric.canvasLayers();
                }else{
                    $scope.clearCanvas();
                    $scope.fabric.addCanvasBackground(image,allcanvasdata);
                    $scope.objectLayers = [];
                    $scope.objectLayers = $scope.fabric.canvasLayers();
                }
                // $scope.activeDesignObject = indexKey;
            }
            if(indexKey == null){
                 indexKey = (typeof indexKey === "undefined" || indexKey === null) ? 0 : indexKey;
              console.log("image",image);
                $scope.clearCanvas();
                setTimeout(function(){ 
                    $scope.fabric.addCanvasBackground(image,allcanvasdata);
                },500);
                
                // setTimeout(function(){ 
                //    // $scope.addText('New Text');
                // }, 1000);

                $scope.defaultPrice = price;
                $scope.orignalPrice = price;
                $scope.defaultCurrency = currency;
                $scope.defaultProductTitle = title;
                _this.initProductSubImages(id);
            }
          }


                   


            $scope.isloaded = true;
            $scope.$broadcast('rebuild:me');
           $scope.activeDesignObject = indexKey;

            const active_main_dessing = $scope.defaultProductId + '_&&_' + $scope.activeDesignObject;
                let verValue = $scope.json_select_opton[active_main_dessing];
                // Normalize result
                if (!verValue || (verValue !== 'Stick' && verValue !== 'Druck')) {
                    verValue = 'Stick';  // default fallback
                }
                      $scope.Veredelung = verValue;
           console.log("$scope.activeDesignObject first",$scope.activeDesignObject);
        };

        this.initProductSubImages = function (id) {   
            console.log("$scope.defaultProductId",$scope.defaultProductId);           
                $scope.defaultProductId = id;

          const matchedProduct = _this.getProductById(id);          
                // $scope.productImages = productImages.images;
          // return;
          // $scope.productImages = productImages.images;
          console.log("matchedProduct",matchedProduct);
          console.log("_this.getProductById(id)",_this.getProductById(id));
          $scope.productImages = matchedProduct.sub_images;
                $scope.fabric.designedObjects = {};
                $.each($scope.productImages, function(index,value){
                    $scope.fabric.designedObjects[index] = null;
                    $scope.fabric.designedSVGObjects[index] = null;
                    $scope.fabric.designedPNGObjects[index] = null;
                    $scope.fabric.designedPNGObjects[index] = null;
                });

          console.log("$scope.fabric.designedObjects",$scope.fabric.designedObjects)
          
                $scope.objectLayers = [];
                $scope.objectLayers = $scope.fabric.canvasLayers();
                $scope.isloaded = false;
           
        };

      this.getProductById = function (id) {
         return selectedproducts.find(product => product.id === id);
      };

        $scope.loadProductchange =  function (event,id) {
                   $scope.avalable_customise = null;
                   $scope.jsonStore = {};
                   $scope.fabric.designedObjects = {};
          $scope.closet_element  = event.target.closest('[data-main-wapper-cust]') || null;
          if(!$scope.closet_element && !id) return;
           const matchedProduct = _this.getProductById(id);

        //    console.log("matchedProduct_loadProductchange",matchedProduct);

           const product_prosnolize =  $scope.closet_element.querySelector('[data-customize')?.getAttribute('data-customize') || null;
            const product_prosnolize_Veredelung =  $scope.closet_element.querySelector('[data-customize-final-veredelung')?.getAttribute('data-customize-final-veredelung') || null;
          // console.log("product_prosnolize",product_prosnolize);
           const product_prosnolize_product_json  = JSON.parse(product_prosnolize) || null;
           const product_prosnolize_Veredelung_json  = JSON.parse(product_prosnolize_Veredelung) || {};

          // console.log($scope.avalable_customise == null);
          // console.log("product_prosnolize_product_json",product_prosnolize_product_json);


           $scope.clearCanvas();
          
          if($scope.avalable_customise == null){
            $scope.avalable_customise = product_prosnolize_product_json;
            $scope.jsonStore = product_prosnolize_product_json;
          }else if(!product_prosnolize_product_json == $scope.avalable_customise){
            $scope.avalable_customise = product_prosnolize_product_json
            $scope.jsonStore = product_prosnolize_product_json;
          }

          console.log("$scope.jsonStore",$scope.jsonStore);
          console.log("$scope.activeDesignObject",$scope.activeDesignObject);
          if(product_prosnolize_Veredelung_json != null){
            $scope.json_select_opton = product_prosnolize_Veredelung_json;
            // console.log("inside_con_$scope.json_select_opton",$scope.json_select_opton,product_prosnolize_Veredelung_json);
          }
        //   console.log("$scope.json_select_opton",$scope.json_select_opton,product_prosnolize_Veredelung_json);

        // if($scope.fabric.designedObjects[indexKey] != null){                  
        //                   $scope.fabric.loadJSON($scope.fabric.designedObjects[indexKey]);
        //                   $scope.objectLayers = [];
        //                   $scope.objectLayers = $scope.fabric.canvasLayers();
        //               }


//         angular.forEach($scope.jsonStore, function(jsonString, indexKey) {

//     if (jsonString && jsonString !== "") {

//         try {
//             // Load each canvas JSON string one-by-one
//             // console.log("indexKey",indexKey);

//                $scope.fabric.designedObjects[indexKey]  = $scope.fabric.exportCanvasObjectAsJson();
//                 $scope.fabric.designedSVGObjects[indexKey] = $scope.fabric.saveCanvasObjectAsSvg();
//                 $scope.fabric.designedPNGObjects[indexKey] = $scope.fabric.saveCanvasObjectAsPng();
//                 $scope.fabric.designedJPGObjects[indexKey] = $scope.fabric.saveCanvasObjectAsJpg();

//             // $scope.fabric.loadJSON(jsonString);
//             // console.log("jsonString",jsonString)
//             //  _this.initProductSubImages(matchedProduct.id);

//             // Update canvas layers
//             $scope.objectLayers = [];
//             $scope.objectLayers = $scope.fabric.canvasLayers();

//         } catch (e) {
//             console.error("Error loading canvas JSON at index:", indexKey, e);
//         }
//     }

// });



          if(product_prosnolize_product_json){
                  $scope.loadProduct(matchedProduct.name, matchedProduct.image, matchedProduct.id, matchedProduct.price, matchedProduct.currency, null , true, matchedProduct.sub_images[0]);
          }else{
            
                  $scope.avalable_customise = null;
                  $scope.jsonStore = {};
                  $scope.loadProduct(matchedProduct.name, matchedProduct.image, matchedProduct.id, matchedProduct.price, matchedProduct.currency, null , false, matchedProduct.sub_images[0]);     
          }
        const main_app = document.querySelector('#main-angular_product_wapper') || null;
        if(main_app) main_app.classList.remove('hidden');
        const main_data_select = document.querySelector("[new_data_edit='outfit']") || null;
        if(main_data_select) main_data_select.classList.add('hidden'); 
        };
        

          $scope.inputIncrement = function (event) {
              let container = event.target.closest('md-input-container');
              if (!container) return;
          
              let input = container.querySelector('input[type="number"]');
              if (!input) return;
          
              let step = parseFloat(input.getAttribute('data-edit-value')) || 1;
              let currentValue = parseFloat(input.value) || 0;
              let newValue = (currentValue + step).toFixed(this.getPrecision(step));
          
              input.value = newValue;
          
              // Trigger AngularJS ng-model update
              angular.element(input).triggerHandler('input');
          };
          
          $scope.inputDecrement = function (event) {
              let container = event.target.closest('md-input-container');
              if (!container) return;
          
              let input = container.querySelector('input[type="number"]');
              if (!input) return;
          
              let step = parseFloat(input.getAttribute('data-edit-value')) || 1;
              let currentValue = parseFloat(input.value) || 0;
              let newValue = (currentValue - step).toFixed(this.getPrecision(step));
          
              input.value = newValue;
          
              // Trigger AngularJS ng-model update
              angular.element(input).triggerHandler('input');
          };
          
          // Helper for decimal precision
          $scope.getPrecision = function (num) {
              return (num.toString().split('.')[1] || '').length;
          };


      // this.initProductSubImages = function (id) {
      //       $http({
      //           method: 'get',
      //           url: $scope.REQUEST_URL.LOAD_PRODUCT_SUB_IMAGES+id+'.json',
      //           dataType : 'json',
      //           headers: {'Content-Type': 'application/json'}
      //       }).success(function (data, status, headers, config) {
      //           $scope.defaultProductId = id;
      //           $scope.productImages = data.images;
      //           $scope.fabric.designedObjects = {};
      //           $.each($scope.productImages, function(index,value){
      //               $scope.fabric.designedObjects[index] = null;

      //               $scope.fabric.designedSVGObjects[index] = null;
      //               $scope.fabric.designedPNGObjects[index] = null;
      //               $scope.fabric.designedPNGObjects[index] = null;

      //           });

      //           console.log($scope.fabric.designedObjects);
      //           $scope.objectLayers = [];
      //           $scope.objectLayers = $scope.fabric.canvasLayers();
      //           $scope.isloaded = false;
      //       }).error(function (data, status, headers, config) {
      //           $scope.isloaded = false;
      //       });
      //   };
      
      

        $scope.shareOnFacebook = function (e){
            e.preventDefault();
            FB.ui(
                {
                    method: 'feed',
                    name: 'Classic blue tees',
                    link: 'http://demo.veesys.com/tshirt/',
                    picture: 'http://demo.veesys.com/tshirt/images/export.png',
                    caption: 'Classic blue tees',
                    description: 'This classic blue will upgrade your casual collection. Made from cotton, this half sleeves tee ensures great comfort all day long. Style it with straight fit denims and sneakers for that smart look.',
                    message: ''
                }
            );
        };

        $scope.shareOnTwitter = function (e){
            e.preventDefault();
            window.open("https://twitter.com/share?url=" + escape(window.location.href) + "&text=" + document.title, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            return false;
        };

        $scope.graphics_load_more = function (page){

            var str = $scope.graphicsCategory;
            var lowerCase = str.toLowerCase();
            var category = lowerCase.replace(" ", "_");

            $http({
                method: 'get',
                url: $scope.REQUEST_URL.LOAD_GRAPHICS+category+'_'+$scope.graphicsPage+'.json',
                dataType : 'json',
                headers: {'Content-Type': 'application/json'}
            }).success(function (data, status, headers, config) {
                if(data.loadMore){
                    $scope.loadMore = true;
                }else{
                    $scope.loadMore = false;
                }
                $scope.graphicsPage = 1+data.page;
                var finalObj = $scope.graphics.concat(data.data_result);
                $scope.graphics = finalObj;
                $scope.$broadcast("AjaxCallHappened",data);
                $scope.$broadcast('rebuild:me');
            }).error(function (data, status, headers, config) {
                $scope.$broadcast("AjaxCallHappened",false);
            });
        };

        $scope.ColorSelector = function (){
            $("#selector_icon").on('click', function(event) {
                $("body").toggleClass('body_overlay');
                $(this).parent(".customizer").toggleClass('customizer_toggle');
                return false;
            });
        };

        $scope.CanvasBgSelector = function (){
            $("#canvas_color_selector > li").on('click', function(event) {
                $('.canvas_section').attr('id', $(this).attr('class'));
                $(".canvas_image").css("background-image","url("+$(this).data("attr")+")");
                $(".customizer").removeClass('customizer_toggle');
                $("body").removeClass('body_overlay');
                return false;
            });
        };
        $scope.CanvasPosition = function (){
            $("#canvas-pos > label").on('click', function(event) {
                var canvas_id = $(this).find("input").attr("id");
                if(canvas_id == "pos_left"){
                    $(".editor_section").addClass("pull-right");
                }else{
                    $(".editor_section").removeClass("pull-right");
                }
            });
        };

        this.transformRequest = function(obj) {
            var str = [];
            for(var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
        };

        this.sanitizePosition = function() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        };

        this.showNotification = function (message, scroll) {

            $mdToast.show(
                $mdToast.simple()
                    .content(message)
                    .position($scope.getToastPosition())
                    .hideDelay(3000)
            );
            if(scroll) {
                $('html, body').animate({scrollTop: $(document).height()}, 1500);
            }
        };

        this.initProducts = function () {
            $scope.productCategory = "all";
          
              console.log("selectedproducts",selectedproducts);
              
                $scope.products = selectedproducts;
                $scope.isloaded = false;
                $scope.$broadcast("AjaxCallHappened",selectedproducts);
            // $http({
            //     method: 'get',
            //     url: $scope.REQUEST_URL.LOAD_PRODUCTS,
            //     dataType : 'json',
            //     headers: {'Content-Type': 'application/json'}
            // }).success(function (data, status, headers, config) {

            //   console.log(data);
            //   console.log(selectedproducts);
              
            //     $scope.products = data.products;
            //     $scope.isloaded = false;
            //     $scope.$broadcast("AjaxCallHappened",selectedproducts);
            // }).error(function (data, status, headers, config) {
            //     $scope.isloaded = false;
            //     $scope.$broadcast("AjaxCallHappened",false);
            // });
        };

        $scope.loadByGraphicsCat = function (val){
            $scope.graphicsCategory = val;
            $scope.graphicsPage = 1;
            _this.initGraphics();
            $scope.graphic_icons = true;
        };

        $scope.ShowGraphicIcons = function (){
            $scope.graphic_icons = false;
        };

        $scope.loadByGraphicsCategory = function (){
            $scope.graphicsPage = 1;
            _this.initGraphics(); 
        };

        this.initGraphics = function () {

            var str = $scope.graphicsCategory;
            var lowerCase = str.toLowerCase();
            var category = lowerCase.replace(" ", "_");

            $http({
                method: 'get',
                url: $scope.REQUEST_URL.LOAD_GRAPHICS+category+'_'+$scope.graphicsPage+'.json',
                dataType : 'json',
                headers: {'Content-Type': 'application/json'}
            }).success(function (data, status, headers, config) {

                if(data.loadMore){
                    $scope.loadMore = true;
                }else{
                    $scope.loadMore = false;
                }
                $scope.graphicsPage = 1+data.page;
                $scope.graphics = data.data_result;
                $scope.isloaded = false;
                $scope.$broadcast("AjaxCallHappened",data);
                $scope.$broadcast('rebuild:me');
            }).error(function (data, status, headers, config) {
                $scope.isloaded = false;
                $scope.$broadcast("AjaxCallHappened",false);
            });
        };

        $scope.loadByProductName = function (){

            if($scope.productByName == 'ASC') {

                $scope.predicate = 'name';
                $scope.reverse = false;

            }else{

                $scope.predicate = 'name';
                $scope.reverse = true;

            }

        };

        this.initSettings = function () {
       $http({
                      method: 'get',
                      url: SETTINGS_INIT_URL,
                      dataType: 'json',
                      headers: {
                          'Content-Type': 'application/json' // ✅ only valid header
                      }
                  }).success(function (data, status, headers, config) {

              console.log(data);


                $scope.NOTIFICATION_MESSAGES = appSettings.settings.notification_messages;
                $scope.REQUEST_URL = appSettings.settings.request_url;


                $scope.fb_app_id = appSettings.settings.social_settings.fb_app_id;

                $scope.graphicsPage = appSettings.settings.general_settings.graphicsPage;
                $scope.defaultProductId = appSettings.settings.general_settings.defaultProductId;
                $scope.defaultProductImage = appSettings.settings.general_settings.defaultProductImage;
                $scope.quantity = appSettings.settings.general_settings.quantity;
                $scope.defaultPrice = appSettings.settings.general_settings.defaultPrice;
                $scope.orignalPrice = $scope.defaultPrice;
                $scope.defaultCurrency = appSettings.settings.general_settings.defaultCurrency;
                $scope.defaultProductTitle = appSettings.settings.general_settings.defaultProductTitle;
                $scope.qrCode = appSettings.settings.general_settings.qrCode;
                $scope.enter_drawing_mode = appSettings.settings.general_settings.enter_drawing_mode;
                $scope.drawing_mode_selector = appSettings.settings.general_settings.drawing_mode_selector;
                $scope.drawing_line_width = appSettings.settings.general_settings.drawing_line_width;
                $scope.drawing_color = appSettings.settings.general_settings.drawing_color;
                $scope.drawing_line_shadow = appSettings.settings.general_settings.drawing_line_shadow;
                $scope.primaryColor = appSettings.settings.general_settings.primaryColor;
                $scope.secondaryColor = appSettings.settings.general_settings.secondaryColor;
                $scope.graphicsCategories = appSettings.settings.general_settings.graphicsCategories;
                // $scope.productCategories = appSettings.settings.general_settings.productCategories;
                $scope.productByNames = appSettings.settings.general_settings.productByNames;
                $scope.graphicsCategory = appSettings.settings.general_settings.graphicsCategory;
                $scope.productByName = appSettings.settings.general_settings.productByName;
                $scope.predicate = appSettings.settings.general_settings.predicate;
                $scope.reverse = appSettings.settings.general_settings.reverse;
                $scope.loadMore = appSettings.settings.general_settings.loadMore;
               $scope.script_address = `${doman_link}`;
                $scope.changeColorScheme();

         // console.log("$scope.",$scope);
         // console.log("FabricConstants",$scope.fabric.textDefaults); 
                // _this.initProducts();
                // $scope.loadProduct($scope.defaultProductTitle, $scope.defaultProductImage,$scope.defaultProductId, $scope.defaultPrice, $scope.defaultCurrency);
                _this.initGraphics();
                $scope.fabric.readyHandTool($scope.drawing_mode_selector, $scope.drawing_color, $scope.drawing_line_width, $scope.drawing_line_shadow);
            }).error(function (data, status, headers, config) {
                $scope.isloaded = false;
            });
        };

        $scope.initFBUi = function (){
            window.fbAsyncInit = function() {
                FB.init({
                    appId      : $scope.fb_app_id,
                    xfbml      : true,
                    version    : 'v2.5'
                });
            };

            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        };

        $scope.init = function () {

                _this.initSettings();

                jQuery(document).on("change", ".upload", function (){
                    jQuery("#uploadFile").val($(this).val());
                });

                $scope.ColorSelector();

                $scope.CanvasBgSelector();

                $scope.CanvasPosition();

                $scope.initFBUi();

            jQuery(window).load(function(){
                 jQuery(".editor_section").height(jQuery(".canvas_section").height()); 
                 jQuery("#Products .thumb_listing ul > li:first-child a").trigger("click");
            });  
            $scope.fabric = new Fabric({
                JSONExportProperties: FabricConstants.JSONExportProperties,
                textDefaults: FabricConstants.textDefaults,
                shapeDefaults: FabricConstants.shapeDefaults,
                curvedTextDefaults: FabricConstants.curvedTextDefaults,
                imageDefaults: FabricConstants.imageDefaults,
                imageFilters: FabricConstants.imageFilters,
                json: {}
            });
            $scope.isloaded = false;
           
        };
        $scope.$on('canvas:created', $scope.init);
        Keypress.onSave(function () {
            $scope.updatePage();
        });
    }
]);
